import { ReactElement, useEffect, useState } from "react";
import { RouteComponentProps, useHistory, useLocation } from "react-router-dom";
import { useDependency } from "../../../contexts/DependencyContext";
import { className } from "../../../shared/helpers";
import useWindowWidth from "../../../hooks/UseWindowWidth";
import { ComponentModelService } from "../../../services/ComponentModelService";
import Spinner from "../../../components/Shared/Spinner";
import FullScreenWidgetHeader from "./FullScreenWidgetHeader";
import styles from "./FullscreenDashboardView.module.scss";
import { useTimeMachine } from "../../../contexts/TimeMachineContext";
import { FullScreenWidgetService } from "../../../services/widgets/FullScreenWidgetService";

interface FullscreenDashboardViewProps
{
    componentId: string;
    widgetId: string;
    widgetType: string;
}

const FullscreenDashboardView = (props: RouteComponentProps<FullscreenDashboardViewProps>): ReactElement | null =>
{
    const history = useHistory();
    const queryString = new URLSearchParams(useLocation().search);
    const timeMachine = useTimeMachine();
    const widgetService = useDependency(FullScreenWidgetService);
    const service = useDependency(ComponentModelService);
    const [currentFilters, setCurrentFilters] = useState<Object | null>(null);
    const isDesktop = useWindowWidth(992);
    const { widgets } = service.componentModel || [];
    const widget = widgets.find(x => x.id === parseInt(props.match.params.widgetId, 10));
    const widgetType = props.match.params.widgetType;
    const widgetName = widgetService.getFullScreenWidgetName(widgetType, isDesktop, widget ? widget.name : "");
    const widgetTitle = queryString.has('name') ? queryString.get('name') : widgetName;

    useEffect(() => {
        if (timeMachine) history.push(`/dashboard/${props.match.params.componentId}/`);
    }, [timeMachine, history, props.match.params.componentId])

    return (
        <div
            {...className(styles.dashboard, "scroll-container")}
            style={{ overflow: !widgets ? "hidden" : "auto" }}
        >
            {!widgets && <Spinner caption="Loading widgets..." />}

            <div className={styles.inner}>
                {widgetName && <FullScreenWidgetHeader title={widgetTitle || ""} />}
                {widgetService.getWidgetFilters(widget, widgetType, setCurrentFilters)}
                {widgetService.getWidgetBody(widget, widgetType, currentFilters, widgets)}
            </div>
        </div>
    );
}

export default FullscreenDashboardView;
